module.exports = "/wp-content/plugins/farmacy/assets/js/images/map-marker-user-location-908a052e0642ffba3bf090ba18fe4f88.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/locations-map/img/map-marker-user-location.png
 ** module id = 403
 ** module chunks = 1 7 9 33 51
 **/